import getConfig from 'next/config'
import Cookies from 'js-cookie'

export const requestUrl = (userId?: string | null) => {
  const { publicRuntimeConfig } = getConfig()
  const { PEEKABOO_API_URL } = publicRuntimeConfig

  return userId ? `${PEEKABOO_API_URL}/${userId}` : PEEKABOO_API_URL
}

const PEEKABOO_SESSION_ID_KEY = 'peekabooSessionId'

function buildPeekabooBody(userAttributes: any) {
  let body = {}

  const peekabooSessionId = getSessionIdFromLocalStorage()
  if (peekabooSessionId) {
    body = {
      sessionId: peekabooSessionId,
      ...body,
    }
  }

  if (userAttributes) {
    body = {
      userAttributes: userAttributes,
      ...body,
    }
  }

  return body
}

const requestInit = (domain?: string, userAttributes?: TODO) => {
  const defaultRequestInit: RequestInit = {
    method: 'post',
    body: JSON.stringify(buildPeekabooBody(userAttributes)),
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-domain': domain || '',
      'x-href': window.location.href,
      'x-host': window.location.host,
      'x-pathname': window.location.pathname,
      'x-search': window.location.search,
    },
  }

  return defaultRequestInit
}

const saveSessionIdToLocalStorage = (sessionId: string) => {
  Cookies.set(PEEKABOO_SESSION_ID_KEY, sessionId, { expires: 365 })
  if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
    window.localStorage.setItem(PEEKABOO_SESSION_ID_KEY, sessionId)
  }
}

const getSessionIdFromLocalStorage = () => {
  const cookieSessionId = Cookies.get(PEEKABOO_SESSION_ID_KEY)
  if (cookieSessionId) {
    return cookieSessionId
  }

  if (typeof window !== 'undefined' && typeof window.localStorage !== 'undefined') {
    const localStorageSessionId = window.localStorage.getItem(PEEKABOO_SESSION_ID_KEY)
    if (localStorageSessionId) {
      return localStorageSessionId
    }
  }

  return null
}

export const fetchExperiments = async (
  userId?: string | null,
  userAttributes?: TODO,
  domain?: string
) => {
  const init = requestInit(domain, userAttributes)
  const response = await fetch(requestUrl(userId), init)
  const json = await response.json()

  saveSessionIdToLocalStorage(json.sessionId)

  return json.experiments
}

export const removeKeyForUndefinedValues = (obj: TODO) =>
  Object.keys(obj).reduce((acc, key) => {
    if (typeof obj[key] !== 'undefined') {
      acc[key] = obj[key]
    }
    return acc
  }, {} as TODO)
